import React, { useState } from "react";
import "../styles/productCard.css";
import { Icon } from "@iconify/react/dist/iconify.js";
import carImage from "../../../assets/default-image.png";
import { useNavigate } from "react-router-dom";
import { usePostUpdateProductStatusMutation } from "../../../rtk-query/slices/createProduct/productDetail/productDetailSlice";
import { toast } from "react-toastify";
import { formatShortScheduleListDate } from "../../../helpers/dateFormatter";
import ProductLanguageModal from "./ProductLanguageModal";
import ProductPricingEditModal from "../modals/ProductPricingEditModal";

function ProductsCard({ productData }) {
  const navigate = useNavigate();
  const [isActive, setIsActive] = useState(
    productData?.product_status?.status_name === "In Active" ? false : true
  );
  const [schedule, setSchedule] = useState([]);
  const [scheduleData, setScheduleData] = useState([]);
  const [showUpdatePriceModal, setShowUpdatePriceModal] = useState(false);
  const [isExclusive, setIsExclusive] = useState(false);
  const [postUpdateProductStatus] = usePostUpdateProductStatusMutation();
  const handleChangeIsActive = async () => {
    setIsActive(!isActive);
    try {
      const response = await postUpdateProductStatus({
        product_id: productData?.id,
      });
      if (response?.data) {
        toast.success(response?.data?.message);
      }
      if (response?.error) {
        toast.error(response?.error?.data?.message);
      }
    } catch (err) {}
  };
  const [showModal, setShowModal] = useState(false);

  const handleLanguageSelect = (language) => {
    console.log("Selected language:", language);
    // Handle language selection logic here
    localStorage.setItem("productLanguage", language);
    navigate("/create-product");
  };

  return (
    <section className="dod-product-listing-card-main" key={productData?.id}>
      <div className="d-flex flex-sm-row flex-column align-items-center dod-product-listing-card ">
        {/* product image */}
        <div className=" position-relative dod-product-listing-card-image-container mb-sm-0 mb-2">
          <img
            src={
              productData?.product_cover_image
                ? productData?.product_cover_image?.product_image_filename
                : carImage
            }
            alt="product"
            className={`dod-product-listing-card-image ${
              !productData?.product_cover_image
                ? "dod-product-listing-card-image"
                : ""
            }`}
          />
          <div className="dod-product-listing-card-image-tag-active d-flex align-items-center ps-2 pe-2 pt-1 pb-1 gap-1">
            <div className="dod-product-listing-card-image-tag-active-circle "></div>
            <p className="m-0 p-0 dod-product-listing-card-image-tag-text">
              {productData?.product_status?.status_name}
            </p>
          </div>
        </div>
        <div className="w-100 d-flex flex-lg-row flex-column ">
          {/* product details */}
          <div className="plc-details flex-1 d-flex flex-column gap-1 align-items-start ps-3 pe-3">
            {/* product code and reviews */}
            <div className="d-flex flex-md-row flex-column gap-2">
              <p className="plc-text-desc m-0 p-0">
                Product code: {productData?.product_code}
              </p>
              <p className="plc-text-desc m-0 p-0 d-flex align-items-center">
                {" "}
                <Icon
                  icon="line-md:star-alt-filled"
                  color="#DEDB15"
                  width={22}
                  height={22}
                />
                ({productData?.product_review_count || 0}) reviews
              </p>
            </div>
            {/* title */}
            <h2 className="plc-title m-0 p-0 w-75">
              {productData?.product_title}
            </h2>
            {/* description */}
            <p
              className="plc-desc m-0 p-0"
              dangerouslySetInnerHTML={{
                __html: productData?.product_overview,
              }}
            ></p>
            {/* persons, date , price */}
            <div className="d-flex flex-row flex-wrap gap-3">
              <div className="plc-price-container d-flex align-items-center gap-1">
                <Icon icon="radix-icons:person" color="#EB662B" fontSize={18} />
                <p className="m-0 p-0 opacity-50">
                  {productData?.product_orders_count} Bookings
                </p>
              </div>
              <div className="plc-price-container d-flex align-items-center gap-1">
                <Icon icon="uil:calender" color="#EB662B" fontSize={18} />
                <p className="m-0 p-0 opacity-50">
                  {formatShortScheduleListDate(
                    productData?.created_at?.split("T")[0]
                  )}
                </p>
              </div>
            </div>

            {/* pricing and edit price section */}
            {productData?.product_options?.length > 0 &&
              productData?.product_options?.map((schedule, index) => {
                return (
                  <React.Fragment key={index}>
                    {schedule?.product_price_schedules?.length > 0 &&
                      schedule?.product_price_schedules?.map(
                        (scheduleData, index) => {
                          return (
                            <div
                              key={index}
                              className="d-flex gap-1 justify-content-between align-items-center w-100"
                            >
                              <p className="d-flex align-items-center gap-1 m-0">
                                {scheduleData?.product_schedule_prices?.map(
                                  (price, index) => (
                                    <span key={index}>
                                      <Icon
                                        icon="ion:pricetag-outline"
                                        color="#EB662B"
                                        fontSize={18}
                                        className="me-1"
                                      />
                                      {
                                        price?.price_category
                                          ?.price_category_name
                                      }
                                      :{" "}
                                      <span>
                                        <span className="text-dark">AED</span>{" "}
                                        <span
                                          style={{ color: "#EB662B" }}
                                          className="fw-bold fs-5"
                                        >
                                          {" "}
                                          {parseInt(price?.discount_price) > 0
                                            ? parseInt(price?.discount_price)
                                            : parseInt(price?.retail_price)}
                                        </span>
                                      </span>{" "}
                                      {parseInt(price?.discount_price) > 0 && (
                                        <span className="text-decoration-line-through opacity-50">
                                          {parseInt(price?.retail_price)}
                                        </span>
                                      )}
                                      {`${
                                        scheduleData?.product_schedule_prices[
                                          index + 1
                                        ]
                                          ? ", "
                                          : ""
                                      }`}
                                    </span>
                                  )
                                )}
                              </p>
                              <Icon
                                style={{
                                  cursor: "pointer",
                                  marginRight: "-33px",
                                  zIndex: 999,
                                }}
                                icon="fluent:edit-32-filled"
                                size={30}
                                color="#eb662b"
                                onClick={() => {
                                  setSchedule(schedule);
                                  setScheduleData(scheduleData);
                                  setIsExclusive(
                                    schedule?.product_option_type == 2
                                      ? true
                                      : false
                                  );
                                  setShowUpdatePriceModal(true);
                                }}
                              />
                            </div>
                          );
                        }
                      )}
                  </React.Fragment>
                );
              })}
          </div>

          {/* buttons */}
          <div className="plc-btns-container d-flex flex-column gap-2 justify-content-center align-items-end pe-4 mt-lg-0 mt-2 ">
            {/* switch button */}
            {/* <div className="plc-switch-btn d-flex gap-2 align-items-center justify-content-center">
              <label class="switch flex-shrink-0">
                <input
                  type="checkbox"
                  checked={isActive}
                  onChange={handleChangeIsActive}
                />
                <span class="slider round"></span>
              </label>
              <p className="m-0 p-0 flex-shrink-0">
                {isActive ? "Active" : "In Active"}
              </p>
            </div> */}
            <div className="d-flex flex-lg-row flex-lg-nowrap flex-wrap align-item-center justify-content-center flex-row gap-2 plc-btns">
              {/* {productData?.product_status?.status_name === "In Process" && (
                <button
                  className="plc-impr-btn mb-0"
                  onClick={() => {
                    localStorage.setItem("productId", productData?.id);
                    setShowModal(true)
                  }}
                >
                  Finish creating
                </button>
              )} */}
              {productData?.product_status?.status_name === "Approved" && (
                <button
                  className="plc-impr-btn mb-0"
                  onClick={() => {
                    const baseUrl = process.env.REACT_APP_WEB_URL;
                    const categorySlug =
                      productData?.product_categories?.[0]?.categories
                        ?.category_slug;
                    const productSlug = productData?.product_slug;
                    if (baseUrl && categorySlug && productSlug) {
                      const url = `${baseUrl}/${categorySlug}/${productSlug}`;
                      window.open(url, "_blank"); // Open in a new tab
                    } else {
                    }
                  }}
                >
                  View
                </button>
              )}
              {productData?.product_status?.status_name !== "Approved" && (
                <button
                  className="plc-impr-btn mb-0"
                  onClick={() => {
                    const baseUrl = process.env.REACT_APP_WEB_URL;
                    const categorySlug =
                      productData?.product_categories?.[0]?.categories
                        ?.category_slug;
                    const productSlug = productData?.product_slug;
                    if (baseUrl && categorySlug && productSlug) {
                      const url = `${baseUrl}/${categorySlug}/${productSlug}/preview`;
                      window.open(url, "_blank"); // Open in a new tab
                    } else {
                    }
                  }}
                >
                  Preview
                </button>
              )}
              {/* {productData?.product_status?.status_name === "In Review" && (
                <button
                  className="plc-impr-btn mb-0"
                  onClick={() => {
                    localStorage.setItem("productId", productData?.id);
                    setShowModal(true)
                  }}
                >
                  Improve
                </button>
              )}
              {(productData?.product_status?.status_name === "Active" ||
                productData?.product_status?.status_name === "In Active" ||
                productData?.product_status?.status_name === "Approved") && (
                <>
                  <button
                    className="plc-impr-btn"
                    onClick={() => {
                      localStorage.setItem("productId", productData?.id);
                      setShowModal(true)
                    }}
                  >
                    Improve
                  </button>
                </>
              )} */}
            </div>
          </div>
        </div>
      </div>
      <ProductLanguageModal
        show={showModal}
        onHide={() => setShowModal(false)}
        onSelect={handleLanguageSelect}
      />
      <ProductPricingEditModal
        show={showUpdatePriceModal}
        handleClose={() => setShowUpdatePriceModal(false)}
        productDetail={productData}
        productId={productData?.id}
        scheduleData={scheduleData}
        schedule={schedule}
        isExclusive={isExclusive}
      />
    </section>
  );
}

export default ProductsCard;
